/** BRACKETED 실패 message 의 응답 코드 접두 — `[409 Conflict] `, `[NotFound] `, `[400 BadRequest] ` */
const STATUS_PREFIX = /^\[[^\]]*\]\s*/;

/**
 * 서버가 사람에게 읽히는 문장 앞에 붙이는 응답 코드 접두(`[409 Conflict] 동일한 이름의 …`)를 떼고 양끝 공백을 지운다.
 * 폴더 쓰기(`describeFolderWriteFailure`)·장비 쓰기(`equipmentWriteFailureMessage`)·소유권 이전(`isTitleConflict`)이
 * 같은 규약의 message 를 받으므로 한 곳에서 정의한다 — 접두 형식이 바뀌면 여기만 고친다.
 */
export function stripStatusPrefix(message: string): string {
  return message.replace(STATUS_PREFIX, "").trim();
}
